import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import ActionsAdFavorite, {actionAdFavoriteTrackingOrigins} from '@adv-mt/mt-actions-ad-favorite'
import ActionsAdReport from '@adv-mt/mt-actions-ad-report'
import ActionsAdShare, {actionAdShareTrackingOrigins} from '@adv-mt/mt-actions-ad-share'

import {BASE_CLASS} from './config.js'

const PanelAdDetailsVehicleActions = ({
  ad,
  contractId,
  extendedTrackingData,
  trackingData,
  isFavorite = false,
  onShowModalAdReport = () => {}
}) => {
  const {domain} = useContext(Context)
  const config = domain.get('config')

  const companyUrl = config.get('COMPANY_URL')
  const adUrl = `${companyUrl}${ad.url}`

  return (
    <div className={`${BASE_CLASS}-actions`}>
      <ActionsAdFavorite
        ad={ad}
        extendedTrackingData={extendedTrackingData}
        isFavorite={isFavorite}
        trackingData={trackingData}
        trackingOrigin={actionAdFavoriteTrackingOrigins.DETAIL_AD_FAVORITED}
      />
      <ActionsAdShare
        ad={ad}
        extendedTrackingData={extendedTrackingData}
        contractId={contractId}
        referer={adUrl}
        trackingOrigin={actionAdShareTrackingOrigins.DETAIL_AD_SHARED}
      />
      <ActionsAdReport adId={ad.id} contractId={contractId} onShowModal={onShowModalAdReport} />
    </div>
  )
}

PanelAdDetailsVehicleActions.propTypes = {
  ad: PropTypes.object,
  contractId: PropTypes.number,
  extendedTrackingData: PropTypes.object,
  trackingData: PropTypes.shape({
    provinces: PropTypes.string
  }),
  isFavorite: PropTypes.bool,
  onShowModalAdReport: PropTypes.func
}

export default PanelAdDetailsVehicleActions
